import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import ProductVariantSelector from '../ProductVariantSelector/ProductVariantSelector';
import AddToCartBtn from '../AddToCartBtn/AddToCartBtn';

import Image from '../Image';

import useSelectedVariant from '../../hooks/useSelectedVariant';

import { getProductHref } from '../../Utils/ProductUtils';
import { getSelectedVariantPrices } from '../../Utils/PriceUtils';

import { StyledHeaderWrapper, StyledHeader, ImageWrapper, StyledCompareAtPrice, StyledCompareAtPercentOff, StyledAnchorWrapper } from './ProductModalStyles';

var ProductModal = function ProductModal(props) {
  var _useSelectedVariant = useSelectedVariant(props.product),
      _useSelectedVariant2 = _slicedToArray(_useSelectedVariant, 4),
      selected = _useSelectedVariant2[0],
      handleOptionChange = _useSelectedVariant2[1],
      variantExists = _useSelectedVariant2[2],
      productModalDataActive = _useSelectedVariant2[3];

  if (props.active && productModalDataActive) {
    var variantPrices = getSelectedVariantPrices(selected.variant);

    var variant_selectors = props.product.options.map(function (option) {
      return React.createElement(ProductVariantSelector, {
        handleOptionChange: handleOptionChange,
        key: option.id.toString(),
        option: option,
        selectedOptions: selected.options,
        showLabel: option.name.toLowerCase() === 'color',
        variants: props.product.variants.edges,
        productId: props.product.id,
        parent: 'ProductModal'
      });
    });

    return React.createElement(
      Modal,
      { active: props.active, closeModalFunc: props.closeProductModal },
      React.createElement(
        StyledHeaderWrapper,
        null,
        React.createElement(
          ImageWrapper,
          null,
          props.product.images.edges.length && React.createElement(Image, {
            src: selected.variant.image.productImg,
            alt: selected.variant.image.altText
          })
        ),
        React.createElement(
          StyledHeader,
          null,
          React.createElement(
            'h5',
            null,
            props.product.title
          ),
          React.createElement(
            'div',
            { className: 'Product__header__price' },
            variantPrices.price,
            variantPrices.isSaleVariant && React.createElement(
              StyledCompareAtPrice,
              null,
              React.createElement(
                's',
                null,
                variantPrices.compareAtPrice
              ),
              React.createElement(
                StyledCompareAtPercentOff,
                null,
                variantPrices.compareAtPercentOff,
                '% Off'
              )
            )
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'Product__functionality' },
        props.product.variants.edges.length > 1 ? variant_selectors : null,
        React.createElement(
          StyledAnchorWrapper,
          null,
          React.createElement(
            'a',
            { href: getProductHref(props.product.handle, selected.variant.id) },
            'More Details'
          )
        ),
        React.createElement(AddToCartBtn, {
          selectedVariantId: selected.variant.id,
          variantExists: variantExists,
          selectedVariantQuantity: 1,
          addVariantToCart: props.addVariantToCart,
          selectedVariantAvailable: selected.variant.availableForSale,
          product: props.product,
          btnStyle: 'MODAL',
          ineligibleForDiscount: props.product.tags.includes('data--no_coupon:1')
        })
      )
    );
  } else {
    return null;
  }
};

ProductModal.propTypes = {
  product: PropTypes.object,
  addVariantToCart: PropTypes.func.isRequired,
  closeProductModal: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired
};

export default ProductModal;